import word_name_box_img from "@/img/ico/word_name_box.png";

function HeadArea(props: any) {
  let myProps = {
    Style: {},
    templete_data_json: {},
    ...props
  };
  let Style = myProps.Style || {};
  let templete_data_json = myProps.templete_data_json || {};

  let title_str_style:any={};
  if(templete_data_json.title_str.length>15){
    title_str_style.fontSize="20px";
  }else if(templete_data_json.title_str.length>25){
    title_str_style.fontSize="16px";
  }

  return (
    <div className={Style.word_title_bar_wrap}>
      <div className={Style.word_title_bar_left}>
        <div className={Style.word_title_bar_logo}>
          <img src={templete_data_json.logo_url} />
        </div>
        <div className={Style.word_title_bar_title} style={title_str_style}>
          {templete_data_json.title_str}
        </div>
      </div>
      <div className={Style.word_title_bar_name_wrap}>
        <img src={word_name_box_img} />
        <div className={Style.word_title_bar_name_con}>
          <div>
            Name: 
            <span className="ml-3" style={{color:"#444444"}}>
              {templete_data_json.stu_name}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};
export default HeadArea;